import React from "react";
import "./component.css";

type Props = {
  title?: string;
  className?: string;
  children?: React.ReactNode;
};

export default function SubmissionFrame({
  title = "SUBMISSIONS",
  className = "",
  children
}: Props) {
  return (
    <div className={`submission-frame ${className}`}>
      <div className="submission-frame__inner">
        <h5 className="frame-title frame-title--red">{title}</h5>
        <div className="submission-body">{children}</div>
      </div>
    </div>
  );
}
